export enum TypeCard {
  GENERIC = 'Generic',
  STEP = 'Step',
  REWARD = 'Reward',
}
